import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Toast, ToastService } from '@core/services/presenters/toast.service';
import { AlertType } from '@core/type/alert.type';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(100%)' }),
        animate('250ms ease-out', style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
})
export class ToastComponent {
  private readonly toastService = inject(ToastService);
  readonly toasts = this.toastService.toasts;

  runAction(toast: Toast): void {
    toast.action?.run();
    this.dismiss(toast.id);
  }

  dismiss(id: string): void {
    this.toastService.dismiss(id);
  }

  borderClass(type: AlertType): string {
    const map: Record<AlertType, string> = {
      success: 'border-success-600 dark:border-success-400',
      error: 'border-destructive-600 dark:border-destructive-400',
      warning: 'border-warning-600 dark:border-warning-400',
      info: 'border-primary-600 dark:border-primary-400',
    };
    return map[type];
  }

  textClass(type: AlertType): string {
    const map: Record<AlertType, string> = {
      success: 'text-success-700 dark:text-success-400',
      error: 'text-destructive-700 dark:text-destructive-400',
      warning: 'text-warning-700 dark:text-warning-400',
      info: 'text-primary-700 dark:text-primary-400',
    };
    return map[type];
  }

  barClass(type: AlertType): string {
    const map: Record<AlertType, string> = {
      success: 'bg-success-600 dark:bg-success-400',
      error: 'bg-destructive-600 dark:bg-destructive-400',
      warning: 'bg-warning-600 dark:bg-warning-400',
      info: 'bg-primary-600 dark:bg-primary-400',
    };
    return map[type];
  }

  iconPath(type: AlertType): string {
    if (type === 'success') {
      return 'M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z';
    }
    if (type === 'error') {
      return 'M9.75 9.75l4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z';
    }
    // warning
    return 'M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z';
  }

  trackById(_: number, toast: Toast): string {
    return toast.id;
  }
}
